export default __webpack_public_path__ + "assets/fonts/1f13f1b02be0e4db1f3d96ee95849587.woff";